import React, { memo, useContext, useEffect, useReducer } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import { useSnackbar } from 'notistack';
import { getDateStringFromDate, getLocalTimeFromDatabaseTime, getMonthStringFromDate, getTimeInAMPMFromDate, getYearStringFromDate } from '../../../../catalog/DateTime';
import './css/EventThumbnail1.css';
import { isValidObject, isValidString } from '../../../../catalog/Validity';
import Button1 from '../../buttons/Button1';
import { context } from '../../../../globalState/GlobalState';
import { fetchTicketsByEventAPI } from '../../../apiCalls/TicketAPICalls';
import { showEventTickets } from '../../../../catalog/Store';

const initialState = {
    tickets: [],
};

function reducer(state, action) {
    switch (action.type) {
        case 'fetchTickets':
            return { ...state, tickets: action.tickets };
        default:
            return initialState;
    }
}

const EventThumbnail1 = (props) => {
    const { id, title, venue, timeOfEvent, endTimeOfEvent } = props;
    const [state, setState] = useReducer(reducer, initialState);
    const { globalState } = useContext(context);
    const history = useHistory();
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        async function fetchTickets() {
            if (isValidObject(globalState.accountId) && isValidString(id)) {
                await fetchTicketsByEventAPI(globalState.accountId, id, setState, enqueueSnackbar);
            }
        }

        fetchTickets();
    }, [globalState.accountId, id]);

    const getTitle = (titleHere) => {
        if (titleHere.length > 45) {
            return `${titleHere.substr(0, 45)}...`;
        }
        return titleHere;
    };

    return (
        <>
            <NavLink key={id} to={`/events/${id}`} className="event-thumbnail1-desktop full-width box-shadow-black curve-border-15px text-black text-no-underline m-t-10px m-b-10px">
                <div className="event-thumbnail1-main-content">
                    <div className="event-thumbnail1-date full-width m-l-20px p-r-20px">
                        <p className="condensed-font-family m-t-0 m-l-0 m-r-0 m-b-0 font-size-l">{getMonthStringFromDate(getLocalTimeFromDatabaseTime(timeOfEvent))}</p>
                        <p className="condensed-font-family m-t-0 m-l-0 m-r-0 m-b-0 font-size-5xl">{getDateStringFromDate(getLocalTimeFromDatabaseTime(timeOfEvent))}</p>
                        <p className="condensed-font-family m-t-0 m-l-0 m-r-0 m-b-0 font-size-l">{getYearStringFromDate(getLocalTimeFromDatabaseTime(timeOfEvent))}</p>
                    </div>
                    <div className="event-thumbnail1-content full-width m-l-20px">
                        <div className="event-thumbnail1-title-container m-l-50px m-r-5px">
                            <p className="alegreya-font-family text-left-align font-size-xl m-t-0 m-b-0">
                                Event
                            </p>
                            <div className="event-thumbnail1-title">
                                <p className="alegreya-font-family text-left-align font-weight-800 text-uppercase font-size-4xl curve-border-5px m-t-0 m-b-0">
                                    {getTitle(title)}
                                </p>
                                {showEventTickets(globalState, state.tickets, endTimeOfEvent)
                                    ? (
                                        <div className="m-l-20px m-r-20px">
                                            <Button1
                                                title="Tickets"
                                                backgroundColor={globalState.websiteStyles.colors.primaryColor}
                                                fontColor={isValidString(globalState.websiteStyles.colors.fontColor) ? `${globalState.websiteStyles.colors.fontColor}` : 'white'}
                                                borderColor="#ffffff"
                                                fontSize="0.8rem"
                                                borderRadius="5px"
                                                width="100px"
                                                height="28px"
                                                onClick={(event) => {
                                                    event.stopPropagation();
                                                    event.preventDefault();
                                                    history.push(`/events/${id}#ticketTitle`);
                                                }}
                                            />
                                        </div>
                                    ) : null}
                            </div>
                            {isValidString(venue) ? (
                                <p className="alegreya-font-family text-left-align font-size-l m-t-0 m-b-0">
                                    {`Venue: ${venue}`}
                                </p>
                            ) : null}
                        </div>
                    </div>
                </div>
                <div className="event-thumbnail1-time-container m-l-0 m-r-20px">
                    <p className="text-right-align condensed-font-family m-t-0 m-b-0 font-size-4xl">{getTimeInAMPMFromDate(getLocalTimeFromDatabaseTime(timeOfEvent))}</p>
                    {timeOfEvent.seconds !== endTimeOfEvent.seconds ? (<p className="text-right-align condensed-font-family m-t-0 m-b-0 font-size-l">{`- ${getTimeInAMPMFromDate(getLocalTimeFromDatabaseTime(endTimeOfEvent))}`}</p>) : null}
                </div>
                <KeyboardArrowRightIcon className="event-thumbnail1-arrow font-size-4xl m-r-20px" />
            </NavLink>
            <NavLink key={id} to={`/events/${id}`} className="event-thumbnail1-mobile full-width box-shadow-black curve-border-15px text-black text-no-underline m-t-10px m-b-10px">
                <div className="event-thumbnail1-main-content p-t-40px p-b-40px">
                    <div className="event-thumbnail1-date-time full-width m-b-30px">
                        <div className="event-thumbnail1-date">
                            <p className="condensed-font-family m-t-0 m-l-0 m-r-0 m-b-0 font-size-s">{getMonthStringFromDate(getLocalTimeFromDatabaseTime(timeOfEvent))}</p>
                            <p className="condensed-font-family m-t-0 m-l-0 m-r-0 m-b-0 font-size-3xl">{getDateStringFromDate(getLocalTimeFromDatabaseTime(timeOfEvent))}</p>
                            <p className="condensed-font-family m-t-0 m-l-0 m-r-0 m-b-0 font-size-s">{getYearStringFromDate(getLocalTimeFromDatabaseTime(timeOfEvent))}</p>
                        </div>
                        <div className="event-thumbnail1-time">
                            <p className="text-right-align condensed-font-family m-t-0 m-b-0 font-size-2xl">{getTimeInAMPMFromDate(getLocalTimeFromDatabaseTime(timeOfEvent))}</p>
                            {timeOfEvent.seconds !== endTimeOfEvent.seconds ? (<p className="text-right-align condensed-font-family m-t-0 m-b-0 font-size-s">{`- ${getTimeInAMPMFromDate(getLocalTimeFromDatabaseTime(endTimeOfEvent))}`}</p>) : null}
                        </div>
                    </div>
                    <div className="event-thumbnail1-content full-width">
                        <p className="alegreya-font-family text-left-align full-width font-size-m m-t-0 m-b-5px">
                            Event
                        </p>
                        <p className="alegreya-font-family text-left-align full-width font-weight-800 text-uppercase font-size-xl curve-border-5px m-t-5px m-b-5px">
                            {title}
                        </p>
                        {showEventTickets(globalState, state.tickets, endTimeOfEvent)
                            ? (
                                <Button1
                                    title="Tickets"
                                    showSilhouetteLogo
                                    backgroundColor={globalState.websiteStyles.colors.primaryColor}
                                    fontColor={isValidString(globalState.websiteStyles.colors.fontColor) ? `${globalState.websiteStyles.colors.fontColor}` : 'white'}
                                    borderColor="#ffffff"
                                    fontSize="0.8rem"
                                    borderRadius="5px"
                                    width="100px"
                                    height="28px"
                                    logoHeight="20px"
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        event.preventDefault();
                                        history.push(`/events/${id}#ticketTitle`);
                                    }}
                                />
                            ) : null}
                        {isValidString(venue) ? (
                            <p className="alegreya-font-family text-left-align full-width font-size-s m-t-5px m-b-0">
                                {`Venue: ${venue}`}
                            </p>
                        ) : null}
                    </div>
                </div>
            </NavLink>
        </>
    );
};

EventThumbnail1.propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    venue: PropTypes.string.isRequired,
    timeOfEvent: PropTypes.object.isRequired,
    endTimeOfEvent: PropTypes.object.isRequired,
};

export default memo(EventThumbnail1);
